import { Injectable } from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class ChangedDocumentService {

  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('ChangedDocumentService');
  }

  /**
   * Listen value changes on a specified document field
   * @param fieldName the field name of document
   * @param documentId the document id
   * @param controlName the registered control that holds the field value in this component. It is used to check on the source of change
   * to avoid applying changes itself and also applying the value from the components that share the field name.
   * @param options provides more information for the watch.
   */
  watch(fieldName, documentId, controlName?, options?) {
    return this.ajsService.watch(fieldName, documentId, controlName, options);
  }

  /**
   * Provide the change information for the specified document field that the component binds to
   * @param component the component binds to the field
   * @param newValue the changed/new value
   * @param controlName the registered control manages the field value
   * @param options the options
   */
  valueChanged(component, value: any, controlName?: string, options?: any) {
    this.ajsService.valueChanged(component, value, controlName, options);
  }

  executeOnFieldChangeWithNoChanges(component) {
    if (this.injector.isAngularJSCore()) {
      console.warn('This feature is not supported on AngularJS Core.');
    } else {
      this.ajsService.executeOnFieldChangeWithNoChanges(component);
    }
  }

  watchDocument(documentId) {
    if (this.injector.isAngularJSCore()) {
      console.warn('This feature is not supported on AngularJS Core.');
      return null;
    } else {
      return this.ajsService.watchDocument(documentId);
    }
  }

  watchStoreChanges() {
    if (this.injector.isAngularJSCore()) {
      console.warn('This feature is not supported on AngularJS Core.');
      return null;
    } else {
      return this.ajsService.watchStoreChanges();
    }
  }

  dispatchAction(action) {
    if (this.injector.isAngularJSCore()) {
      console.warn('This feature is not supported on AngularJS Core.');
    } else {
      this.ajsService.dispatchAction(action);
    }
  }

  watchComponentTemplate(templateId) {
    if (this.injector.isAngularJSCore()) {
      console.warn('This feature is not supported on AngularJS Core.');
    } else {
      return this.ajsService.watchComponentTemplate(templateId);
    }
  }

  notifyIntializedField(component, shouldDispatchEmptyFieldValue?) {
    if (this.injector.isAngularJSCore()) {
      console.warn('This function is not supported on AngularJS Core.');
    } else {
      return this.ajsService.notifyIntializedField(component, shouldDispatchEmptyFieldValue);
    }
  }
}
